import { useContext, useEffect } from "react";
import { Backdrop, CircularProgress, Container } from "@mui/material";
import DesktopView from "./components/DesktopView";
import ErrorPage from "../ErrorPage/ErrorPage";
import ActivationFormContext from "../../store/activation-form-context";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { customTheme } from "../../util/constants";
import MobileView from "./components/MobileView";

const UserInfoPage = () => {
  const { errorMessage, errorTitle, errorButtonConfig, loading } = useContext(ActivationFormContext);

  const { width: screenWidth } = useWindowDimensions();

  useEffect(() => {
    window.gtag("config", "G-5F7QGXG61T", {
      client_id: localStorage.getItem("client_id"),
      session_id: localStorage.getItem("session_id"),
    });
  }, []);

  return errorMessage ? (
    <ErrorPage message={errorMessage} buttonConfig={errorButtonConfig} title={errorTitle} />
  ) : (
    <Container style={{ minWidth: "100%", minHeight: "100%" }} disableGutters>
      {screenWidth > customTheme.breakpoints.values.md ? <DesktopView /> : <MobileView />}
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Container>
  );
};
export default UserInfoPage;
